import React from "react";
import { Box, Card } from "@mui/material";
import { COLORS } from "../../../styles/uiConstants";

/**
 * Liste sayfası kabuğu: tam yükseklik, tek kart, sayfa scroll'u yok.
 * Scroll ListView gövdesinde olur; toolbar ve sayfalama sabit kalır.
 */
export default function ListPageShell({ children, sx = {} }) {
  return (
    <Box sx={{ height: "100%", p: { xs: 0, sm: 1.5 }, overflow: "hidden", ...sx }}>
      <Card
        elevation={0}
        sx={{
          height: "100%",
          minHeight: 0,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          borderRadius: { xs: 0, sm: 3 },
          border: `1px solid ${COLORS.slate200}`,
          bgcolor: COLORS.white,
        }}
      >
        {children}
      </Card>
    </Box>
  );
}
